import React, { useEffect, useState } from 'react';
import Closed from './Tabs/Closed/Closed';
import CustomerSlots from './Tabs/CustomerSlots/CustomerSlots';
import ExceptionalOpening from './Tabs/ExceptionalOpening/ExceptionalOpening';
import OpeningHours from './Tabs/OpeningHours/OpeningHours';
import classes from './Calendar.module.css';
import {
  fetchCalendarAndSlots,
  fetchWorkingHours,
  selectCalendarAndSlots,
  selectWorkingHours,
  updateCalendarAndSlots,
  updateWorkingHours,
} from '../../store/slices/calendarAndSlots';
import { useAppDispatch, useAppSelector } from '../../store/store';

import PrimaryButtonV2 from '../../components/UI/Buttons/PrimaryButtonV2';
import WorkingHours from './Tabs/WorkingHours/WorkingHours';
import { Tabs } from '../../components/UI/Tabs/Tabs';
import { useTranslation } from '../../hooks/useTranslations';

const Calendar: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();
  const [tabSelected, setTabSelected] = useState(0);
  const [mainTabSelected, setMainTabSelected] = useState(1);
  const [openingHoursModal, setOpeningHoursModal] = useState<number>();

  const calendarAndSlots = useAppSelector<any>(selectCalendarAndSlots);
  const workingHours = useAppSelector<any>(selectWorkingHours);

  const TABS = ['appointment.hours', 'closed', 'exceptional.opening', 'customer.slots'];
  const MAINTABS = [
    { tabName: 'appointment.calendar', tabIndex: 0 },
    { tabName: 'working.hours', tabIndex: 1 },
  ];

  const fetchData = async () => {
    const response = await dispatch(fetchCalendarAndSlots());
    if (tabSelected == 0) setTabSelected(1);
    return response;
  };
  const fetchWorkingHoursData = async () => {
    const response = await dispatch(fetchWorkingHours());
    // if (tabSelected == 1) setTabSelected(1);
    return response;
  };

  useEffect(() => {
    fetchData();
  }, [mainTabSelected]);
  const refreshPage = () => {
    fetchData();
    fetchWorkingHoursData();
  };
  const handleSave = async () => {
    if (mainTabSelected === 1) {
      await dispatch(updateCalendarAndSlots(calendarAndSlots));
    } else {
      const postWorkingHours = [
        {
          calendar_items: workingHours,
        },
      ];
      await dispatch(updateWorkingHours(postWorkingHours[0]));
    }
  };

  const handleSelectTab = (idx: number) => {
    setMainTabSelected(idx);
    setTabSelected(0);
  };

  return (
    <div className={classes.mainContainer}>
      <Tabs tabs={MAINTABS} selectedTabIdx={mainTabSelected} setSelectedTabIdx={handleSelectTab} />
      <div className={classes.container}>
        <div className={classes.content}>
          {mainTabSelected === 1 && (
            <div className={classes.tabs}>
              {TABS.map((tab, index) => (
                <div
                  key={tab}
                  className={`${classes.tab} ${
                    tabSelected === index + 1 ? classes.selectedTab : ''
                  }`}
                  onClick={() => {
                    setTabSelected(index + 1);
                  }}
                >
                  {translations(tab)}
                </div>
              ))}
            </div>
          )}

          {tabSelected >= 1 && mainTabSelected === 1 && (
            <div style={{ minHeight: 320 }}>
              {tabSelected === 1 && (
                <OpeningHours
                  isModalOpen={openingHoursModal === 1}
                  onModalClose={() => setOpeningHoursModal(undefined)}
                  setOpeningHoursModal={setOpeningHoursModal}
                />
              )}
              {tabSelected === 2 && (
                <Closed
                  isModalOpen={openingHoursModal === 2}
                  onModalClose={() => setOpeningHoursModal(undefined)}
                  setOpeningHoursModal={setOpeningHoursModal}
                />
              )}
              {tabSelected === 3 && (
                <ExceptionalOpening
                  isModalOpen={openingHoursModal === 3}
                  onModalClose={() => setOpeningHoursModal(undefined)}
                  setOpeningHoursModal={setOpeningHoursModal}
                />
              )}
              {tabSelected === 4 && <CustomerSlots />}
            </div>
          )}
          {mainTabSelected === 2 && (
            <WorkingHours
              isModalOpen={openingHoursModal === 1}
              onModalClose={() => setOpeningHoursModal(undefined)}
            />
          )}
        </div>
        <div className={classes.buttonsContainer}>
          {tabSelected < 4 && (
            <PrimaryButtonV2
              disabled={false}
              invertedColors={true}
              text={translations('add')}
              onClick={() => setOpeningHoursModal(tabSelected)}
              containerStyle={{
                marginRight: 20,
              }}
              buttonStyle={{
                height: 50,
                width: 180,
              }}
            />
          )}
          <PrimaryButtonV2
            disabled={false}
            resetColors={true}
            text={translations('button.reset')}
            onClick={refreshPage}
            containerStyle={{
              marginRight: 20,
            }}
            buttonStyle={{
              height: 50,
              width: 180,
            }}
          />
          <PrimaryButtonV2
            // disabled={workingHours.length === 0}
            invertedColors={false}
            text={translations('button.save')}
            onClick={handleSave}
            containerStyle={{
              marginRight: 20,
            }}
            buttonStyle={{
              height: 50,
              width: 180,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Calendar;
